import React from "react";
import HStack from "@components/layout/HStack";

type Props = {
  placeholder?: string;
  className?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  isHighlightBorder?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input = ({ placeholder, className, leftIcon, rightIcon, isHighlightBorder = false, ...props }: Props) => {
  return (
    <HStack
      className={`${className} w-full rounded-[4px] border-[1px] border-solid border-mediumGray bg-white px-[10px] py-[6px] dark:bg-darkBackgroundColor dark:border-midGray ${
        isHighlightBorder ? "border-b-[2px] border-b-primaryBlue" : ""
      }`}
      gap={1}
    >
      {leftIcon ? leftIcon : null}
      <input
        type="text"
        placeholder={placeholder}
        // text-mediumDarkGray dark:text-secondaryGray
        className="w-full h-full outline-none dark:bg-darkBackgroundColor"
        {...props}
      />
      {rightIcon ? rightIcon : null}
    </HStack>
  );
};

export default Input;
